import { api } from './api';

export interface BackupInfo {
  filename: string;
  size: number;
  createdAt: string;
  type: 'scheduled' | 'manual';
  status: 'completed' | 'failed' | 'in_progress';
}

export interface BackupStats {
  totalBackups: number;
  totalSize: number;
  oldestBackup?: string;
  newestBackup?: string;
  scheduledBackups: number;
  manualBackups: number;
}

export class BackupService {
  static async createBackup(): Promise<{ message: string; backup: BackupInfo }> {
    const response = await api.post('/backup');
    return response.data;
  }

  static async listBackups(): Promise<{ backups: BackupInfo[]; stats: BackupStats }> {
    const response = await api.get('/backup');
    return response.data;
  }

  static async getBackupStats(): Promise<BackupStats> {
    const response = await api.get('/backup/stats');
    return response.data;
  }

  static async restoreBackup(filename: string): Promise<{ message: string; backup: string }> {
    const response = await api.post(`/backup/restore/${filename}`);
    return response.data;
  }

  static async deleteBackup(filename: string): Promise<{ message: string; backup: string }> {
    const response = await api.delete(`/backup/${filename}`);
    return response.data;
  }

  static async testConnection(): Promise<{ connected: boolean; message: string }> {
    const response = await api.get('/backup/test-connection');
    return response.data;
  }
}